var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScenario5White(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.31 8.297l-1.37-1.371.993-.995L18 9.001l-3.067 3.068-.994-.995 1.37-1.37h-4.03V8.296h4.03zm-2.626 8.297h5.306V18H0V2.11C0 .945.946 0 2.108 0h8.468c1.163 0 2.108.946 2.108 2.11v4.78H11.28V2.11c0-.388-.315-.704-.703-.704h-.823c.078.22.12.457.12.703v14.485h1.406v-5.485h1.405v5.485zm-11.279 0h7.063V2.109c0-.387-.315-.703-.703-.703H2.108c-.387 0-.703.316-.703.703v14.485zm4.972-8.297c-.378 0-.685.307-.685.685 0 .379.307.686.685.686.379 0 .685-.307.685-.686 0-.378-.306-.685-.685-.685z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario5White);
export default __webpack_public_path__ + "static/media/scenario-5-white.391d23773dbe795433f3acc89b278808.svg";
export { ForwardRef as ReactComponent };